import WooCommerceAPI from 'woocommerce-api'
import store from '@/store/store'

// import store from '@/store'
// const API =  "https://veki.pl";
// const API =  "http://localhost";
const API =  "https://devveki.ctit.pl";
// create an axios instance
const sevice = new WooCommerceAPI({
  url: API,
  consumerKey: 'ck_03cfe3e1b5355fa6149cf49eb3e8076196e5a50c',
  consumerSecret: 'cs_ddc3f07694a118899d758f4b1bb42ef591ba9d1c',
  wpAPI: true,
  version: 'wc/v3'
});

export default sevice
